import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, from } from 'rxjs';

import { IServiceResponseUsuario } from './core/models/services/response-app/response-app.interface';
import { LoaderProfileService } from './core/services/loader-profile/loader-profile.service';
import { StoreService } from './core/services/store/store.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  userResponse = {} as IServiceResponseUsuario;
  denied: boolean;

  constructor(private router: Router, private storeService: StoreService, private loader: LoaderProfileService) {}

  canActivate(): Promise<boolean> {
    const promise = new Promise<boolean>((resolve) => {
      const observableFromPromise = from(this.storeService.profile || new BehaviorSubject<IServiceResponseUsuario>(this.userResponse));
      const deniedObservable = from(this.loader.denyAccess$ || new BehaviorSubject<boolean>(false));

      deniedObservable.subscribe((isDenied) => {
        this.denied = isDenied;
        if (this.denied) {
          this.router.navigateByUrl('negado');
          resolve(false);
        }
      });

      observableFromPromise.subscribe((user) => {
        if (user.empresas.length > 0) {
          resolve(true);
        }
      });
    });

    return promise.then((x) => x);
  }
}
